/* eslint-disable no-use-before-define */
import geraData, { geraDataNuvem } from '../geradata';

export default function dadosTabelas() {
  /*
  nomeapi: => { opcional } NOME DA TABELA NA API,
  campoatt: => CAMPO PARA UTILIZAR NA HORA DA ATUALIZACAO,
  prefixo: => PREFIXO DA TABELA LOCAL,
  model => MODEL DO BANCO LOCAL,
  */
  return {
    movimentacaoveiculo: {
      campoatt: 'movdataalteracao',
      prefixo: 'mov',
      model: movimentacaoveiculo,
    },
    veiculo: {
      campoatt: 'veidataatualizacao',
      prefixo: 'vei',
      model: veiculo,
    },
    eventosveiculos: {
      nomeapi: 'eventosveiculo',
      campoatt: 'evvdataalteracao',
      prefixo: 'evv',
      model: eventosveiculos,
    },
    itemmovimentacaoveiculo: {
      campoatt: 'imvdataalteracao',
      prefixo: 'imv',
      model: itemmovimentacaoveiculo,
    },
    veiculoatividade: {
      campoatt: 'veadataalteracao',
      prefixo: 'vea',
      model: veiculoatividade,
    },
    apontamentoembarque: {
      campoatt: 'apedataalteracao',
      prefixo: 'ape',
      model: apontamentoembarque,
    },
    contrato: {
      campoatt: 'condataalteracao',
      prefixo: 'con',
      model: contrato,
    },
    contratomp: {
      campoatt: 'cmpdataalteracao',
      prefixo: 'cmp',
      model: contratomp,
    },
  };
}

function resolverDataAlt(dataPrincipal, dataBruta) {
  if (dataPrincipal) return geraDataNuvem(dataPrincipal);
  if (dataBruta) return geraDataNuvem(dataBruta);
  return geraDataNuvem();
}

export function movimentacaoveiculo(item) {
  const dataBruta = item.movdataalteracao || item.movdatanuvem || item.movdataenvio || item.movdata;
  const dataFallback = (dataBruta ? geraData(dataBruta) : null) || geraData();
  const dataAlt = resolverDataAlt(item.movdataalteracao, dataBruta);
  const dataNuv = item.movdatanuvem ? geraDataNuvem(item.movdatanuvem) : dataAlt;
  return {
    movidnuvem: item.id,
    movidmovimentacaoveiculo: item.movidmovimentacaoveiculo,
    movidveiculo: item.movidveiculo,
    movideventoveiculo: item.movideventoveiculo,
    movidfornecedor: item.movidfornecedor,
    movvalortipo: item.movvalortipo,
    movdata: item.movdata ? (geraData(item.movdata) || item.movdata) : dataFallback,
    movobservacao: item.movobservacao,
    movtipo: item.movtipo,
    movtipomanutencao: item.movtipomanutencao,
    movidpessoaexecutor: item.movidpessoaexecutor,
    movidpropriedade: item.movidpropriedade,
    movgarantiaate: item.movgarantiaate ? geraData(item.movgarantiaate) : null,
    movidatividade: item.movidatividade,
    movidempresa: item.movidempresa,
    movdatanuvem: dataNuv,
    movdataalteracao: dataAlt,
    movidmovimentacaonuvem: item.movidmovimentacaonuvem,
    movdeletar: item.movdeletar ?? 0,
    movenviado: item.movenviado || null,
    enviado: item.enviado || null,
  };
}

export function veiculo(item) {
  const dataBruta = item.veidataatualizacao || item.veidataalteracao || item.veidatanuvem;
  const dataAtt = resolverDataAlt(item.veidataatualizacao, dataBruta);
  const dataAlt = item.veidataalteracao ? geraDataNuvem(item.veidataalteracao) : dataAtt;
  const dataNuv = item.veidatanuvem ? geraDataNuvem(item.veidatanuvem) : dataAtt;
  return {
    veiidnuvem: item.id,
    veiidveiculo: item.veiidveiculo,
    veifrota: item.veifrota,
    veimarca: item.veimarca,
    veiplaca: item.veiplaca,
    veiplacacomplementar: item.veiplacacomplementar,
    veitipo: item.veitipo,
    veitipomaquinario: item.veitipomaquinario,
    veidataatualizacao: dataAtt,
    veidatanuvem: dataNuv,
    veidataalteracao: dataAlt,
    veiidveiculonuvem: item.veiidveiculonuvem,
    veideletar: item.veideletar ?? 0,
  };
}

export function eventosveiculos(item) {
  const dataBruta = item.evvdataalteracao || item.evvdatanuvem;
  const dataAlt = resolverDataAlt(item.evvdataalteracao, dataBruta);
  const dataNuv = item.evvdatanuvem ? geraDataNuvem(item.evvdatanuvem) : dataAlt;
  return {
    evvidnuvem: item.id,
    evvideventoveiculo: item.evvideventoveiculo,
    evvdescricao: item.evvdescricao,
    evvinativo: item.evvinativo,
    evvdataalteracao: dataAlt,
    evvdatanuvem: dataNuv,
    evvideventoveiculosnuvem: item.evvideventoveiculosnuvem,
    evvdeletar: item.evvdeletar ?? 0,
  };
}

export function itemmovimentacaoveiculo(item) {
  const dataBruta = item.imvdataalteracao || item.imvdatanuvem || item.imvdataenvio;
  const dataAlt = resolverDataAlt(item.imvdataalteracao, dataBruta);
  const dataNuv = item.imvdatanuvem ? geraDataNuvem(item.imvdatanuvem) : dataAlt;
  return {
    imvidnuvem: item.id,
    imviditemmovimentacaoveiculo: item.imviditemmovimentacaoveiculo,
    imvidmovimentacaoveiculo: item.imvidmovimentacaoveiculo,
    imvidmovimentacaonuvem: item.imvidmovimentacaonuvem,
    imvtiposervico: item.imvtiposervico,
    imvidproduto: item.imvidproduto,
    imvdescricaoproduto: item.imvdescricaoproduto,
    imvunidadedemedida: item.imvunidadedemedida,
    imvquantidade: item.imvquantidade,
    imvprecounitario: item.imvprecounitario,
    imvidlocalarmazenamento: item.imvidlocalarmazenamento,
    imvobservacao: item.imvobservacao,
    imvvalortotal: item.imvvalortotal,
    imvdataalteracao: dataAlt,
    imvdatanuvem: dataNuv,
    imviditemmovimentacaoveiculonuvem: item.imviditemmovimentacaoveiculonuvem,
    imvdeletar: item.imvdeletar ?? 0,
    imvenviado: item.imvenviado || null,
    enviado: item.enviado || null,
  };
}

export function veiculoatividade(item) {
  const dataBruta = item.veadataalteracao || item.veadatanuvem;
  const dataAlt = resolverDataAlt(item.veadataalteracao, dataBruta);
  const dataNuv = item.veadatanuvem ? geraDataNuvem(item.veadatanuvem) : dataAlt;
  return {
    veaidnuvem: item.id,
    veaidveiculoatividade: item.veaidveiculoatividade,
    veadescricao: item.veadescricao,
    veainativo: item.veainativo,
    veadataalteracao: dataAlt,
    veadatanuvem: dataNuv,
    veaidveiculoatividadenuvem: item.veaidveiculoatividadenuvem,
    veadeletar: item.veadeletar ?? 0,
  };
}

export function apontamentoembarque(item) {
  const dataBruta = item.apedataalteracao || item.apedatanuvem;
  const dataAlt = resolverDataAlt(item.apedataalteracao, dataBruta);
  const dataNuv = item.apedatanuvem ? geraDataNuvem(item.apedatanuvem) : dataAlt;
  return {
    apeidnuvem: item.id || item.apeidapontamentonuvem || item.apeidnuvem,
    apeidapontamentoembarque: item.apeidapontamentoembarque || item.id,
    apetipomidia: item.apetipomidia,
    apedata: item.apedata ? (geraData(item.apedata) || item.apedata) : geraData(),
    apeidplaca: item.apeidplaca,
    apeplaca: item.apeplaca,
    apeidmotorista: item.apeidmotorista,
    apemotorista: item.apemotorista,
    apecontratomp: item.apecontratomp,
    apeidprodutor: item.apeidprodutor,
    apeprodutor: item.apeprodutor,
    apeidpropriedade: item.apeidpropriedade,
    apepropriedade: item.apepropriedade,
    apeidproduto: item.apeidproduto,
    apeproduto: item.apeproduto || item.produto || null,
    apeidtalhao: item.apeidtalhao,
    apetalhao: item.apetalhao,
    apeiddestino: item.apeiddestino,
    apedestino: item.apedestino,
    apeobservacao: item.apeobservacao,
    apelatitude: item.apelatitude,
    apelongitude: item.apelongitude,
    apeidempresa: item.apeidempresa,
    apedatanuvem: dataNuv,
    apedataalteracao: dataAlt,
    apeidapontamentonuvem: item.apeidapontamentonuvem || item.id,
    apedataenvio: item.apedataenvio,
    enviado: 1,
    apeenviado: 1,
  };
}

export function contrato(item) {
  const dataBruta = item.condataalteracao || item.condatanuvem;
  const dataAlt = resolverDataAlt(item.condataalteracao, dataBruta);
  const dataNuv = item.condatanuvem ? geraDataNuvem(item.condatanuvem) : dataAlt;
  return {
    conidnuvem: item.id,
    conidcontrato: item.conidcontrato,
    connumero: item.connumero,
    condata: item.condata ? (geraData(item.condata) || item.condata) : geraData(),
    consituacao: item.consituacao,
    conidempresa: item.conidempresa,
    consafra: item.consafra,
    conidpessoa: item.conidpessoa,
    conidpropriedade: item.conidpropriedade,
    concaminho: item.concaminho,
    condatafechamento: item.condatafechamento ? (geraData(item.condatafechamento) || item.condatafechamento) : null,
    condataalteracao: dataAlt,
    condatanuvem: dataNuv,
    condeletar: item.condeletar ?? 0,
  };
}

export function contratomp(item) {
  const dataBruta = item.cmpdataalteracao || item.cmpdatanuvem;
  const dataAlt = resolverDataAlt(item.cmpdataalteracao, dataBruta);
  const dataNuv = item.cmpdatanuvem ? geraDataNuvem(item.cmpdatanuvem) : dataAlt;
  return {
    cmpidnuvem: item.id,
    cmpidcontrato: item.cmpidcontrato,
    cmpiditemcontrato: item.cmpiditemcontrato,
    cmpidproduto: item.cmpidproduto,
    cmpnrocontrato: item.cmpnrocontrato,
    cmpdatacontrato: item.cmpdatacontrato ? (geraData(item.cmpdatacontrato) || item.cmpdatacontrato) : geraData(),
    cmpidpessoa: item.cmpidpessoa,
    cmpnomepessoa: item.cmpnomepessoa,
    cmpsituacao: item.cmpsituacao,
    cmppesocontrato: item.cmppesocontrato,
    cmppesocancelado: item.cmppesocancelado,
    cmppesoliquido: item.cmppesoliquido,
    cmpvalorsaca: item.cmpvalorsaca,
    cmptipo: item.cmptipo,
    cmpvalorpago: item.cmpvalorpago,
    cmpvalorcontrato: item.cmpvalorcontrato,
    cmpsaldo: item.cmpsaldo,
    cmpquilosaca: item.cmpquilosaca,
    cmpdataalteracao: dataAlt,
    cmpdatanuvem: dataNuv,
    cmpdeletar: item.cmpdeletar ?? 0,
  };
}
